// extracted by mini-css-extract-plugin
module.exports = {"cartTotal":"styles_cartTotal__pHCIH","title":"styles_title__1s4Eq","price":"styles_price__sCboe"};